import React, { useState } from 'react';
import { useCallbackObservable } from 'react-use-observable';

import { App, Button, Spin, Tooltip } from 'antd';

import Truncate from 'components/Truncate';
import { empty } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import type { IChargebackFiles } from 'v2/interfaces/chargeback';
import chargebackService from 'v2/services/chargeback';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  data: IChargebackFiles;
  invoiceId: number;
  setUpload: () => void;
}

const ChargebackDetailsListItem = ({ data, invoiceId, setUpload }: IProps) => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);

  const [removeFile] = useCallbackObservable(() => {
    setLoading(true);
    return chargebackService.removeChargebackFile(invoiceId, data.id).pipe(
      tap(() => {
        setUpload();
        setShow(false);
        message.success('Arquivo excluído com sucesso!');
      }),
      catchError(() => {
        message.error('Falha ao excluir arquivo');
        return empty();
      }),
      finalize(() => setLoading(false))
    );
  }, [invoiceId, data, message, setUpload]);

  if (!show) {
    return null;
  }

  return (
    <div className='flex items-center justify-between border-b border-(--uizz-antd-color-border) px-4 py-3'>
      <Tooltip placement='top' title={`${data.name}.${data.ext}`}>
        <Truncate count={40} final={'...'}>{`${data.name}.${data.ext}`}</Truncate>
      </Tooltip>
      <Button type='text' shape='circle' onClick={removeFile} icon={loading ? <Spin size='small' /> : <Icon.X />} />
    </div>
  );
};

export default ChargebackDetailsListItem;
